<script setup lang="ts">
const props = defineProps<{
  password: string;
}>();

const length8 = computed(() => props.password.length >= 8);
const upper = computed(() => /[A-Z]/.test(props.password));
const lower = computed(() => /[a-z]/.test(props.password));
const digit = computed(() => /\d/.test(props.password));
const special = computed(() => /[!@#$%^&*(),.?":{}|<>]/.test(props.password));

const { t } = useI18n();
</script>

<template>
  <div class="text-red-500 text-small whitespace-break-spaces">
    <div v-if="!upper || !lower || !digit || !special || !length8">
      {{ t('Password_must') }}
    </div>

    <ul class="list-disc pl-5">
      <li v-if="!upper">
        {{ t('Password_at_least_upper') }}
      </li>
      <li v-if="!lower">
        {{ t('Password_at_lowercase') }}
      </li>
      <li v-if="!digit">
        {{ t('Password_at_digit') }}
      </li>
      <li v-if="!special">
        {{ t('Password_at_special', { at: '@' }) }}
      </li>
      <li v-if="!length8">
        {{ t('Password_at_least_8') }}
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>
